import { ADDED_GROUPS_TO_PERSON } from './constants';

export function addedGroupsToPerson(personId: number, groupIds: number[]) {
    return {
        type: ADDED_GROUPS_TO_PERSON,
        payload: {
            personId,
            groupIds
        }
    };
}
